var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNl = function SvgNl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    transform: "scale(1.25 .9375)"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    height: 509.76,
    width: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    height: 169.92,
    width: 512,
    y: 342.08,
    fill: "#21468b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ae1c28",
    d: "M0 0h512v169.92H0z"
  }))));
};
export default __webpack_public_path__ + "assets/fe4bfff4af9ca12cf4783116a4179fed.svg";
export { SvgNl as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/nl.svg